import {createAction} from "redux-act";

export const toggleMenu = createAction<boolean>();
export const toggleDropdownMenu = createAction<boolean>();
export const toggleSubMenu = createAction<string | null>();
